<template>
  <div class="login_content">
    <van-nav-bar
      left-text="返回"
      @click="$router.go(-1)"
      left-arrow
      title="用户信息"
    />

    <van-form @submit="Login">
      <div class="uploadHeads">
        <van-uploader v-model="HeadSculptureList" multiple :max-count="1" />
      </div>
      <van-cell-group inset>
        <van-field
          v-model="AccountModel.Name"
          name="姓"
          label="姓"
          placeholder="姓"
        />
        <van-field
          v-model="AccountModel.LastName"
          name="名"
          label="名"
          placeholder="名"
        />
        <van-field
          v-model="AccountModel.Account"
          name="用户名"
          label="用户名"
          placeholder="用户名"
        />
        <van-field
          v-model="AccountModel.Phone"
          name="手机号"
          label="手机号"
          placeholder="手机号"
        />
        <van-field
          v-model="AccountModel.Email"
          name="邮箱"
          label="邮箱"
          placeholder="邮箱"
        />   
      </van-cell-group>

      <div style="margin: 16px">
        <p>
          <router-link to="register" />
        </p>
        <van-button
          @click="Update"
          round
          block
          type="primary"
          native-type="submit"
        >
          修改
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script >
import axios from "../../commons/AxiosMethod.js";
import { Toast } from "vant";
export default {
  data() {
    return {
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
     
      HeadSculptureList: [], //头像列表
      AccountModel: {}, //注册信息
    };
  },
  name: "App",

  components: {},
  mounted() { 
    this.GetUserInfo();
    
  },
  methods: {
  
    //提交注册
    Update() {
      let param = {};
      axios.apiMethod(
        "/api/User/UpdateUserInfo",
        "post",
        this.AccountModel,
        (result) => {
          if (result.Code == 200) {
            if (result.Data.Success) {
              Toast({
                type: "html",
                message: "注册成功",
              });
              axios.ToLogin();
            } else {
              var html = "";
              result.Data.Msg.forEach((e) => {
                html += "<p>" + e + "</p>";
              });
              Toast({
                type: "html",
                message: html,
              });
            }
          }
        }
      );
    },
     //获取用户信息
    GetUserInfo() {
      var param = {};
      axios.apiMethod("/api/User/GetUserInfo", "get", param, (result) => {
        if (result.Code == 200) {
          this.AccountModel = result.Data;
        
        }
      });
    },
  
  },
};
</script>

<style lang="less" scoped>
.uploadHeads {
  width: 100%;
  text-align: center;
  margin-top: 40px;
}
</style> 